import React, { useState, useEffect } from "react";
import { Layout, Button } from "antd";
import { Outlet } from "react-router-dom";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";

const { Content } = Layout;

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isMobileView, setIsMobileView] = useState(
    window.innerWidth < 1024 || /iPad|iPhone|iPod/.test(navigator.userAgent)
  );
  const [sidebarVisible, setSidebarVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isTabletOrMobile =
        window.innerWidth < 1024 || /iPad|iPhone|iPod/.test(navigator.userAgent);
      setIsMobileView(isTabletOrMobile);
      if (!isTabletOrMobile) {
        setSidebarVisible(false); // Réinitialiser sur desktop
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleCollapsed = () => {
    if (isMobileView) {
      setSidebarVisible(!sidebarVisible);
    } else {
      setCollapsed(!collapsed);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar desktop */}
      {!isMobileView && (
        <Sidebar collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      )}

      {/* Drawer mobile / iPad pour la navigation */}
      {isMobileView && sidebarVisible && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50"
          onClick={toggleCollapsed}
        >
          <div
            className="h-full w-1/2 max-w-sm bg-white shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <span className="text-lg font-medium">Menu</span>
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={toggleCollapsed}
              />
            </div>
            <div className="p-0 h-[calc(100%-56px)] overflow-y-auto">
              <Sidebar
                collapsed={true}
                toggleCollapsed={toggleCollapsed}
                isMobile
              />
            </div>
          </div>
        </div>
      )}

      {/* Layout principal */}
      <Layout
        style={{
          marginLeft: isMobileView ? 0 : collapsed ? 80 : 200,
          transition: "margin-left 0.2s",
        }}
        className="main-container"
      >
        <Content
          style={{
            background: "#f0f2f5",
            minHeight: 280,
            padding: 0,
            margin: 0,
          }}
        >
          {/* Header mobile / iPad avec burger à gauche et logo centré */}
          {isMobileView && (
            <div className="flex items-center justify-between px-4 py-3 bg-white shadow-sm">
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={toggleCollapsed}
              />
              <div className="flex-1 flex justify-center">
                <img
                  src="/monogramme-honnore-noir.png"
                  alt="Intra MK"
                  className="h-8 object-contain"
                />
              </div>
              {/* Espace à droite pour équilibrer la grille */}
              <div style={{ width: 32 }} />
            </div>
          )}

          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
